import { Box } from '@vk-hr-tek/ui/Box';
import { Typography } from '@vk-hr-tek/ui/Typography';
import { Link } from '@vk-hr-tek/ui/Link';
import { Icon } from '@vk-hr-tek/ui/Icon';
import { toDateDeclensionMonth } from '@vk-hr-tek/ui/format';

import { SearchEventOption } from '../SearchInput.types';

interface SearchOptionEventProps {
  option: SearchEventOption;
}

export const SearchOptionEvent = ({ option }: SearchOptionEventProps) => {
  const getDateTime = (since: string, till: string) => {
    const sinceDate = new Date(since);
    const tillDate = new Date(till);

    const formatTime = (date: Date) => {
      return new Intl.DateTimeFormat('ru-RU', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      }).format(date);
    };

    const isSameDay =
      sinceDate.getDate() === tillDate.getDate() &&
      sinceDate.getMonth() === tillDate.getMonth() &&
      sinceDate.getFullYear() === tillDate.getFullYear();

    if (isSameDay) {
      const fullDateTime = toDateDeclensionMonth(sinceDate.toDateString());
      const timeTo = formatTime(tillDate);

      return `${fullDateTime} - ${timeTo}`;
    } else {
      const dateTimeFrom = toDateDeclensionMonth(sinceDate.toDateString());
      const dateTimeTo = toDateDeclensionMonth(tillDate.toDateString());

      return `${dateTimeFrom} - ${dateTimeTo}`;
    }
  };

  return (
    <Box width="100%" p="8">
      <Link href={option.link} variant="simple" display="block">
        <Box display="flex" alignItems="center" gap="12">
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            radius="m"
            bgcolor="bg.greyscale.secondary"
            minHeight="40px"
            minWidth="40px"
            height="40px"
            width="40px"
          >
            <Icon
              name="calendar_check_outline"
              size="24"
              color="accent.text.success"
            />
          </Box>
          <Box
            flex={1}
            display="flex"
            flexDirection="column"
            gap="2"
            maxHeight="60px"
          >
            <Box display="flex" gap="4">
              <Typography
                variant="caption"
                color="text.light.tertirary"
                maxLinesCount={1}
                wordBreak="break-all"
              >
                {getDateTime(option.since, option.till)}
              </Typography>
              <Icon
                name="circle_small_filled"
                color="text.dark.secondary"
                size="16"
              />
              <Typography
                variant="caption"
                color="text.light.tertirary"
                maxLinesCount={1}
                wordBreak="break-all"
              >
                {option.format === 'online' ? 'Онлайн' : option.place}
              </Typography>
            </Box>
            <Box>
              <Typography
                maxLinesCount={2}
                variant="body3"
                color="text.light.primary"
                wordBreak="break-all"
              >
                {option.name}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Link>
    </Box>
  );
};
